function Order(){
    return(
        <div className="order">
            <h1>Order page</h1>
        </div>
    )
}
export default Order;